<template>
    <h1>Esta es la página de inicio</h1>
</template>

<script setup>

</script>
